// extracted by mini-css-extract-plugin
export default {"test":"Test_test__vTrSW"};